import utils from "../../lib/utils";

//cSpell: ignore onlinepages, picbook, putao, fightgroup, mycourse

export const MoreSettingItems = [
    {
        type: 'set_password',
        text: '设置密码',
        hasArrow: true,
        link: '',
    },
    {
        type: 'course_pause',
        text: '学习中可暂停',
        hasArrow: false,
        link: '',
    },
    {
        type: 'device_management',
        text: '绑定管理',
        hasArrow: true,
    },
    {
        type: 'course_record',
        text: '学习中录屏',
        hasArrow: false,
        link: '',
    },
    {
        type: 'clear_history',
        text: '清除缓存',
        hasArrow: true,
    },
    {
        type: 'use_low_course_resource',
        text: '使用低画质学习资源',
        hasArrow: false,
    }
];


// WEBPACK FOOTER //
// ./src/static/json/setting-data.js